<template>
    <div class="invited-artist-container">
        <div class="invited-artists">
            <div
                v-for="artist in artists"
                :key="`${artist.id}-${artist.invited}`"
                class="invited-artist-wrapper"
            >
                <div class="invited-artist">
                    <img
                        v-if="artist.avatar"
                        :src="artist.avatar"
                        class="artist-avatar"
                        alt="artist-avatar"
                    />
                    <span class="artist-invite">{{ artist.invited }}</span>
                    <button
                        @click="
                            $emit('remove-artist', artist.id, artist.invited, artist.artistId)
                        "
                        class="remove-btn"
                    >
                        <img
                            src="/images/icons/close.svg"
                            class="close-icon"
                            alt="close-icon"
                        />
                    </button>
                </div>
            </div>
        </div>
        <div class="shadow-overlay"></div>
    </div>
</template>
<script>
    export default {
        name: 'invited-artists',
        props: {
            invitedArtists: {
                type: Array,
                required: false,
                default: () => []
            }
        },
        emits: ['remove-artist'],
        computed: {
            artists() {
                const artists = []
                const nonNullInvites = this.invitedArtists.filter((artist) => artist.invited)

                nonNullInvites.forEach((a) => {
                    if (a.invited.length > 1) {
                        a.invited.forEach((invite) => {
                            artists.push({
                                id: a.id,
                                artistId: a.artistId,
                                avatar: a.avatar,
                                invited: invite
                            })
                        })
                    } else {
                        if (!artists.find((artist) => artist.artistId === a.artistId)) {
                            artists.push({
                                id: a.id,
                                artistId: a.artistId,
                                avatar: a.avatar,
                                invited: a.invited[0]
                            })
                        } else if (!a.artistId) {
                            artists.push({
                                id: a.id,
                                artistId: a.artistId,
                                avatar: a.avatar,
                                invited: a.invited[0]
                            })
                        }
                    }
                })
                return artists
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }
    .invited-artist-container {
        position: relative;

        .shadow-overlay {
            pointer-events: none;
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 38px;
            background: linear-gradient(
                180deg,
                rgba(38, 38, 38, 0) 0%,
                rgba(38, 38, 38, 0.97) 100%
            );
        }
        .invited-artists::-webkit-scrollbar {
            width: 8px;
        }
        .invited-artists::-webkit-scrollbar-track {
            background-color: none;
        }
        .invited-artists::-webkit-scrollbar-thumb {
            max-height: 64px;
            border-radius: 8px;
            background: #8b8b8b;
        }
        .invited-artists {
            display: flex;
            width: 100%;
            height: 100%;
            max-height: 132px;
            justify-content: flex-start;
            align-items: center;
            overflow-y: auto;
            gap: 8px;
            flex-wrap: wrap;

            .invited-artist-wrapper {
                padding-right: 8px;
                padding-bottom: 8px;

                .invited-artist {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                    padding: 5px;
                    border: 1px solid #8b8b8b;
                    border-radius: 100px;
                    height: 38px;

                    .artist-avatar {
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        object-fit: cover;
                    }
                    .artist-invite {
                        color: #8b8b8b;
                        font-family: 'Instrument Sans';
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 130%;
                        letter-spacing: 0.14px;
                    }
                    .remove-btn {
                        background: none;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 4.62px;
                        width: 18px;
                        height: 18px;

                        .close-icon {
                            width: 14px;
                            height: 14px;
                        }
                    }
                }
            }
        }
    }
</style>
